import { DecryptionStrategySelector } from 'features/e2ee/core/DecryptionStrategySelector';
import { DecryptionContext } from 'features/e2ee/core/decryption-strategies';
import { E2eeReceiver } from 'features/e2ee/E2eeReceiver';
import { E2EEWhiteboardManager } from 'features/e2ee/E2EEWhiteboardManager';
import type { EncryptedData } from 'features/e2ee/types';

export class DataDecryptor {
  constructor(whiteboard: E2EEWhiteboardManager) {
    DecryptionStrategySelector.init(whiteboard);
  }

  async decryptRemoteData(
    data: EncryptedData,
    receiver: E2eeReceiver,
    context: DecryptionContext = {}
  ): Promise<void> {
    const strategies = DecryptionStrategySelector.selectFor(data);

    await Promise.all(strategies.map((strategy) => strategy.decrypt(data, receiver, context)));
  }
}
